import { TFunction } from 'react-i18next';

import { AudienceSyncSchedule, AudienceSyncScheduleType, AudienceSyncTimeBasedSchedule } from '../../../../models/audiences';

type schedule = {
  scheduleType: AudienceSyncScheduleType;
  scheduleConfiguration: AudienceSyncSchedule;
};

export const validateSchedule = ({ scheduleType, scheduleConfiguration }: schedule, t: TFunction<'audience_edit'>) => {
  const errors: Record<string, string> = {};

  if (!scheduleType) {
    errors['scheduleType'] = t('selectType');
  }

  if (scheduleType !== 'SCHEDULED') {
    return errors;
  }

  const repeatConfiguration: AudienceSyncTimeBasedSchedule = scheduleConfiguration as AudienceSyncTimeBasedSchedule;

  if (!repeatConfiguration.startsOn) {
    errors['scheduleConfiguration.startsOn'] = t('selectStartDate');
  }

  if (!repeatConfiguration.repeatsEvery || repeatConfiguration.repeatsEvery < 1) {
    errors['scheduleConfiguration.startsOn'] = t('selectAPositiveRepeatInterval');
  }

  if (!repeatConfiguration.unit) {
    errors['scheduleConfiguration.startsOn'] = t('selectARepeatUnit');
  }

  if (repeatConfiguration.unit === 'WEEKS' && (!repeatConfiguration.weekDays || !repeatConfiguration.weekDays.length)) {
    errors['scheduleConfiguration.startsOn'] = t('selectWeekdaysToRunSyncing');
  }

  if (repeatConfiguration.unit === 'MONTHS' && (!repeatConfiguration.dayOfMonth || repeatConfiguration.dayOfMonth < 1 || repeatConfiguration.dayOfMonth > 31)) {
    errors['scheduleConfiguration.startsOn'] = t('selectDayOfTheMonthToRunSyncing');
  }

  return errors;
};
